import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';
import Input from '../Input';

const defaultProps = {
  type: 'text',
  placeholder: '',
  required: false,
  value: '',
  hasError: false,
  userHide: false,
  disabled: false,
  onChange: () => {},
  onBlur: () => {},
};

const propTypes = {
  type: PropTypes.oneOf([
    'text',
    'email',
    'phone',
  ]),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  hasError: PropTypes.bool,
  userHide: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

const FormControl = ({
  type,
  placeholder,
  required,
  value,
  hasError,
  userHide,
  disabled,
  onChange,
  onBlur,
  ...rest
}) => {
  const props = rest;

  if (type === 'text'
    || type === 'email'
    || type === 'phone') {
    props.placeholder = placeholder;
  }

  return (
    <Flex direction="col">
      <Input
        type={type}
        className={classnames(
          'border shadow rounded py-2 px-4 h-10 text-base',
          !hasError && 'border-gray-400 focus:border-green-500 focus:shadow-outline-green',
          hasError && 'border-red-400 focus:border-red-500 focus:shadow-outline-red',
          userHide && 'hidden',
          disabled && 'opacity-50 pointer-events-none',
        )}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
        {...props}
      />
    </Flex>
  );
};

FormControl.defaultProps = defaultProps;
FormControl.propTypes = propTypes;

export default FormControl;
